import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpeakerSimpleLow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.8412 9.94263C19.2479 10.3119 19.5336 10.8806 19.5336 11.6148C19.5336 12.3492 19.2479 12.9178 18.8412 13.2872",
		stroke: "currentColor",
		strokeWidth: 1.42,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.20369 9.5994C5.08668 10.232 5 10.9358 5 11.615C5 12.2942 5.08668 12.998 5.20369 13.6306C5.42838 14.8454 6.39998 15.8584 7.69407 16.0323C8.01413 16.0752 8.38664 16.112 8.82565 16.1389C9.8721 16.2029 10.8179 16.7548 11.3815 17.589C11.6023 17.9159 11.8356 18.2349 12.0768 18.5375C13.1609 19.8978 14.8512 19.1121 14.925 17.4119C14.9865 15.9926 15.036 14.0837 15.036 11.615C15.036 9.14617 14.9865 7.23744 14.925 5.81817C14.8512 4.11773 13.1609 3.33228 12.0768 4.69249C11.8356 4.99518 11.6023 5.31412 11.3815 5.64096C10.8179 6.47526 9.8721 7.02716 8.82565 7.09107C8.38664 7.1179 8.01413 7.15473 7.69407 7.19772C6.39998 7.37147 5.42838 8.38457 5.20369 9.5994Z",
		stroke: "currentColor",
		strokeWidth: 1.42,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSpeakerSimpleLow;
